import clsx from 'clsx';

interface ILoadingAvatarProps {
  className?: string;
}

/**
 * -----------------------------------------------------------------------------
 * This renders a fallback avatar placeholder component that displays a
 * gray rounded square with a text that is being loaded.
 */
export function LoadingAvatar({ className }: ILoadingAvatarProps) {
  return (
    <div
      className={clsx(
        `
          before:animate-shimmer relative mx-0.5 h-8 w-8 overflow-hidden rounded-lg
          bg-gray-100 bg-gradient-to-r from-gray-200/30
          before:absolute before:inset-0 before:-translate-x-full before:rounded-sm
          before:bg-gradient-to-r before:from-gray-200/20 before:via-gray-300/20
          before:to-transparent
          rtl:bg-gradient-to-l before:rtl:-translate-x-full before:rtl:bg-gradient-to-l
        `,
        className
      )}
    />
  );
}
